var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"burger",class:{ open: _vm.isOpen },on:{"click":function($event){return _vm.$emit('toggle', !_vm.isOpen)}}},[_c('span',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }